// Custom hook to handle drag-end behavior in a sortable list
const useHandleDragEnd = ({fields, getValues, update, move}) => {
  return (event) => {
    const { active, over } = event;

    // Ignore if there's no destination or if the item is dropped on itself
    if (!over || active.id === over.id) return;

    // Find indices of the dragged item and the drop target
    const oldIndex = fields.findIndex((f) => f.id === active.id);
    const newIndex = fields.findIndex((f) => f.id === over.id);

    // Abort if either index is not found (should not happen in normal usage)
    if (oldIndex === -1 || newIndex === -1) return;

    // Logging for debugging drag movements


    // Move only the active item to the new index (preserving other data)
    move(oldIndex, newIndex);
  };
};

export default useHandleDragEnd;
